import React, { useEffect, useRef } from "react";
import * as d3 from "d3";

export default function ForceFieldSpheres({ nodes, edges, width = 600, height = 400 }) {
    const svgRef = useRef();

    useEffect(() => {
        if (!nodes.length) return;

        const svg = d3.select(svgRef.current);
        svg.selectAll("*").remove(); 

        const container = svg.append("g");

        // 🔍 Panning and Zooming Logic
        const zoom = d3.zoom().on("zoom", (event) => {
            container.attr("transform", event.transform);
        });
        svg.call(zoom);

        // 🪐 Force Field Simulation Logic
        const simulation = d3.forceSimulation(nodes)
            .force("link", d3.forceLink(edges).id(d => d.id).distance(100))
            .force("charge", d3.forceManyBody().strength(-300)) // Repulsion
            .force("center", d3.forceCenter(width / 2, height / 2));

        // 🔗 Edges (Relationships)
        const link = container.append("g")
            .selectAll("line")
            .data(edges)
            .join("line")
            .attr("stroke", "#444")
            .attr("stroke-width", 1.5)
            .attr("stroke-opacity", 0.6);

        // ⚪ Nodes (Spheres)
        const node = container.append("g")
            .selectAll("circle")
            .data(nodes)
            .join("circle")
            .attr("r", 18)
            .attr("fill", "#007bff")
            .attr("stroke", "#fff")
            .attr("stroke-width", 2)
            .call(d3.drag() // Dragging support
                .on("start", (e) => {
                    if (!e.active) simulation.alphaTarget(0.3).restart();
                    e.subject.fx = e.subject.x;
                    e.subject.fy = e.subject.y;
                })
                .on("drag", (e) => {
                    e.subject.fx = e.x;
                    e.subject.fy = e.y;
                })
                .on("end", (e) => {
                    if (!e.active) simulation.alphaTarget(0);
                    e.subject.fx = null;
                    e.subject.fy = null;
                }));

        // 🏷️ Node Labels
        const label = container.append("g")
            .selectAll("text")
            .data(nodes)
            .join("text")
            .text(d => d.label)
            .attr("font-size", "11px")
            .attr("font-weight", "bold")
            .attr("dx", 24)
            .attr("dy", 4);

        simulation.on("tick", () => {
            link.attr("x1", d => d.source.x).attr("y1", d => d.source.y)
                .attr("x2", d => d.target.x).attr("y2", d => d.target.y);
            node.attr("cx", d => d.x).attr("cy", d => d.y);
            label.attr("x", d => d.x).attr("y", d => d.y);
        });
    }, [nodes, edges, width, height]);

    return (
        <div className="border rounded bg-white shadow-inner overflow-hidden">
            <svg ref={svgRef} width="100%" height={height} viewBox={`0 0 ${width} ${height}`} />
        </div>
    );
}